// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2k21K","checkboxCol":"Table_checkboxCol__1rqnS","emailCol":"Table_emailCol__3ryGZ","actionCol":"Table_actionCol__-6WBA"};